/*
import {
  hf,
  cr,
  ls,
  gs,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as hf from './_hf';

import * as icm from './icm';

import * as icvBaseD10Rz from './icvBaseD10Rz';
import * as icvI18D11Co from './icvI18D11Co';
import * as icvI18D12Co from './icvI18D12Co';
import * as icvI18D13Co from './icvI18D13Co';

export const N = () => {

  const _gUserz = gs.useUserz();
  const _i19ra1220i = _gUserz.crt.i19rz?.i19ra1220i;

  const _sPz = ls.usePagez({
    steps: [0],
    ctt: 'i',
    diffz: icm.grtDffz({
      role: 'd',
      mode: 'i',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz._fst,
    frcUdt: _sPz.udt,
  })

  return (
    cr.c(icvBaseD10Rz.N, {
      key: -10,
      sPz: _sPz,
      cz: {
        bHome: false,
        bLgt: false,
      },
      oClds: [

        hf.i(_i19ra1220i, [10, 20, 30]) && _sPz.crt.steps[0] == 0 ?
        cr.c(icvI18D11Co.N, {
          key: -10,
          sPz: _sPz,
        })
        : null,

        hf.i(_i19ra1220i, [20, 30]) && _sPz.crt.steps[0] == 1 ?
        cr.c(icvI18D12Co.N, {
          key: -20,
          sPz: _sPz,
        })
        : null,

        hf.i(_i19ra1220i, [10, 20, 30]) && _sPz.crt.steps[0] == 2 ?
        cr.c(icvI18D13Co.N, {
          key: -30,
          sPz: _sPz,
        })
        : null,

      ],
    })
  );
};
